import _define_property from "@swc/helpers/src/_define_property.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { ArticleHeader, ContainerArticle, DetailsPage, MainArticle } from "styles/jss/Layout.styles";
import { Container, useTheme } from "@mui/material";
import { DateStamp, NextImage, PostContent, Redirect } from "components";
import { RandomNews, GallerySection } from "components/PagesComponents/News&Tender";
import { PageContainer } from "components/PagesComponents";
import { getNewsList, getRandomNewsItem } from "services/news.api";
import { getImageUrl } from "utils/helperFunction";
import ShareButton from "components/PagesComponents/News&Tender/ShareButton";
import { DivRow } from "styles/jss/Home.styles";
function NewsPage() {
    var ref, ref1, ref2;
    var ref3 = useRouter(), locale = ref3.locale, query = ref3.query;
    var theme = useTheme();
    var ref4 = useQuery([
        "news-".concat(query.id)
    ], function() {
        return getNewsList(locale, {
            filters: {
                slug: {
                    $eq: query.slug
                },
                id: {
                    $eq: query.id
                }
            }
        });
    }), _data = ref4.data, _data1 = _sliced_to_array(_data.data, 1), newsDetails = _data1[0];
    var ref5 = useQuery([
        "random-news"
    ], function() {
        return getRandomNewsItem(query.id, locale);
    }, {
        onError: function() {
            return console.log("random data is empty");
        },
        refetchInterval: false,
        refetchOnWindowFocus: false
    }), randomNews = ref5.data;
    if (!newsDetails) {
        return /*#__PURE__*/ _jsx(Redirect, {});
    }
    var newsUrl = "".concat(process.env.NEXT_PUBLIC_URL, "/").concat(locale, "/media-center/news/").concat(query.id);
    return /*#__PURE__*/ _jsx(PageContainer, {
        seo_info: {
            title: newsDetails.attributes.title,
            description: newsDetails.attributes.short_description,
            image: (ref = newsDetails.attributes.thumbnail.data) === null || ref === void 0 ? void 0 : ref.attributes.formats
        },
        banner: newsDetails.attributes.thumbnail,
        children: /*#__PURE__*/ _jsx(DetailsPage, {
            children: /*#__PURE__*/ _jsxs(Container, {
                sx: _define_property({}, theme.breakpoints.down("md"), {
                    px: "0"
                }),
                children: [
                    /*#__PURE__*/ _jsx(MainArticle, {
                        children: /*#__PURE__*/ _jsxs(ContainerArticle, {
                            children: [
                                /*#__PURE__*/ _jsxs(ArticleHeader, {
                                    children: [
                                        /*#__PURE__*/ _jsx("h1", {
                                            className: "title",
                                            children: newsDetails.attributes.title
                                        }),
                                        /*#__PURE__*/ _jsxs(DivRow, {
                                            children: [
                                                /*#__PURE__*/ _jsx(DateStamp, {
                                                    date: newsDetails.attributes.datetime,
                                                    time: true
                                                }),
                                                /*#__PURE__*/ _jsx(ShareButton, {
                                                    newsUrl: newsUrl
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                newsDetails.attributes.show_thumbnail && !!newsDetails.attributes.thumbnail.data ? /*#__PURE__*/ _jsx("div", {
                                    className: "imageWrapper",
                                    children: /*#__PURE__*/ _jsx(NextImage, {
                                        src: (ref2 = getImageUrl((ref1 = newsDetails.attributes.thumbnail.data) === null || ref1 === void 0 ? void 0 : ref1.attributes.formats, [
                                            "large",
                                            "medium"
                                        ])) === null || ref2 === void 0 ? void 0 : ref2.url,
                                        alt: newsDetails.attributes.title,
                                        layout: "responsive",
                                        width: 880,
                                        height: 580,
                                        objectFit: "cover",
                                        placeholder: "blur"
                                    })
                                }) : null,
                                /*#__PURE__*/ _jsx(PostContent, {
                                    description: newsDetails.attributes.description
                                }),
                                !!newsDetails.attributes.gallery.data && /*#__PURE__*/ _jsx(GallerySection, {
                                    images: newsDetails.attributes.gallery.data
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(RandomNews, {
                        news: randomNews
                    })
                ]
            })
        })
    });
}
export var __N_SSG = true;
export default _withSuperJSONPage(NewsPage);
